const MOBILE_APP_CATEGORY_ALIAS = 'mobile-app';

/**
 * The shared backend keeps `mobile-app` active for the separate mobile application.
 * The storefront excludes it only from category-group surfaces: the lobby and sidebar.
 */
export const filterStorefrontCategoryGroups = <T extends { alias: string }>(items: T[] | undefined): T[] =>
  (items ?? []).filter(category => category.alias !== MOBILE_APP_CATEGORY_ALIAS);
